import { Button, Modal } from 'react-bootstrap';

import Common from '../../../../stores/Common';
import { ICollabModalProps } from '../modals/CollabModalContext';
import { IUserAuditModel } from '../../../../interfaces/Report/IReport';

export interface IHistoryModalData {
    reportGuid: string;
    history: IUserAuditModel[];
}

export const HistoryModal: React.FC<ICollabModalProps<IHistoryModalData, () => void>> = (props) => {
    if (!props.open || !props.data?.reportGuid) return null;

    return (
        <Modal centered size="lg" show={props.open} backdropClassName="transparent-background">
            <Modal.Header>
                <Modal.Title>Report History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.data.history.length > 0 ? (
                    <table className="table mb-4">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>User</th>
                                <th>Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.data.history.map((item) => (
                                <tr key={item.user.guid + item.dateUTC}>
                                    <td>{Common.dateTimeFormatToLocal(item.dateUTC)}</td>
                                    <td>
                                        {item.user!.profile!.firstName +
                                            ' ' +
                                            item.user!.profile?.lastName}
                                    </td>
                                    <td>{item.details}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div>No history exists for this report.</div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={props.onClose}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
